<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link
          class="text-indigo-400 hover:text-indigo-600"
          :href="route('profile')">
          Profile
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
        <span :class="isEmailVerified" class="text-indigo-600" />
      </h1>
      <img
        v-if="user.photo"
        class="block w-8 h-8 rounded-full ml-4"
        :src="user.photo">
    </div>
    <trashed-message
      v-if="user.deleted_at"
      class="mb-6"
      @restore="restore">
      This user has been deleted.
    </trashed-message>
    <div v-if="isInputDisabled" class="mb-2">
      <span class="text-red-500">*) Nama, Email, dan Data Rekening Mahasiswa tidak dapat diedit
        setelah proses pengajuan beasiswa.</span>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.first_name"
            :error="form.errors.first_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Depan"
            :disabled="isInputDisabled" />
          <text-input
            v-model="form.last_name"
            :error="form.errors.last_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Belakang"
            :disabled="isInputDisabled" />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            :label="labelEmailVerified"
            :disabled="isInputDisabled" />
          <text-input
            v-model="form.bank_acc_number"
            :error="form.errors.bank_acc_number"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nomor Rekening Bank"
            :disabled="isInputDisabled" />
          <div class="break" />
          <text-input
            v-model="form.old_password"
            :error="form.errors.old_password"
            class="pr-6 pb-8 w-full lg:w-1/3"
            type="password"
            autocomplete="old-password"
            label="Password Lama" />
          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="pr-6 pb-8 w-full lg:w-1/3"
            type="password"
            autocomplete="password"
            label="Password Baru" />
          <text-input
            v-model="form.password_confirmation"
            :error="form.errors.password_confirmation"
            class="pr-6 pb-8 w-full lg:w-1/3"
            type="password"
            autocomplete="password-confirmation"
            label="Konfirmasi Password" />
          <!--file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" /-->
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update
            Profile
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `${this.form.first_name} ${this.form.last_name}`,
        }
    },
    components: {
        LoadingButton,
        TextInput,
        TrashedMessage,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        user: Object,
        verificationStatus: Object,
    },
    remember: 'form',
    data () {
        return {
            form: useForm({
                _method: 'put',
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                old_password: null,
                password: null,
                password_confirmation: null,
                bank_acc_number: this.user.bank_acc_number,
            }),
        }
    },
    computed: {
        isInputDisabled () {
            return this.verificationStatus
                ? this.verificationStatus.id > 1
                : false
        },
        labelEmailVerified () {
            return this.user.verified
                ? 'Email [verified]'
                : 'Email [not verified]'
        },
        isEmailVerified () {
            return this.user.verified ? 'fas fa-check-circle' : ''
        },
    },
    methods: {
        update () {
            this.form.post(this.route('profile.update', this.user.id), {
                onSuccess: () =>
                    this.form.reset(
                        'password',
                        'password_confirmation',
                        'old_password',
                    ),
            })
        },
    },
}
</script>

